import React from 'react';
import PlaceResolver, { variants } from 'components/placeResolver/PlaceResolver';
import { getInfuseSpotConfig } from 'api/infuse/service';
import { getScripts } from './utils';

const InfuseSpotComponent = () => {
  const attachScript = (results) => {
    const scripts = getScripts();
    const attached = scripts.filter((script) =>
      script?.src?.toLowerCase().includes(results?.spotURL?.toLowerCase())
    );

    // in case it's already attached
    if (attached.length && window.sprint) {
      window.sprint('login');
      return;
    }
    let snippetUrl = `${results.spotURL}?dt=${results.defaultTag}&r=${Math.random()}`;
    if (!results.defaultTag) {
      snippetUrl = `${results.spotURL}?r=${Math.random()}`;
    }

    const protocol = window.location.protocol;
    let tags = [
      ['src', [protocol === 'https:' ? 'https:/' : 'http:/', snippetUrl].join('/')],
      ['type', 'text/javascript'],
      ['async', true]
    ];

    if (snippetUrl.indexOf('http://') === 0 || snippetUrl.indexOf('https://') === 0) {
      tags = [
        ['src', snippetUrl],
        ['type', 'text/javascript'],
        ['async', true]
      ];
    }

    const script = document.createElement('script');
    const head = document.getElementsByTagName('head')[0];

    setTimeout(() => {
      for (let i = 0, l = tags.length; i < l; i += 1) {
        script.setAttribute(tags[i][0], tags[i][1]);
      }
      head.appendChild(script);
    }, 0);
  };

  return (
    <PlaceResolver variant={variants.input} services={[getInfuseSpotConfig]}>
      {({ results }) => {
        const { data = {} } = results[0];
        if (!data || !data.spotEnabled || !data.spotEnabled) {
          return null;
        }
        return <section>{attachScript(data)}</section>;
      }}
    </PlaceResolver>
  );
};
export default InfuseSpotComponent;
